import script from "./_search-scope.vue?vue&type=script&setup=true&lang=js"
export * from "./_search-scope.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__